import { render, staticRenderFns } from "./CustomExportsInductions.vue?vue&type=template&id=36e26ca6&scoped=true"
import script from "./CustomExportsInductions.vue?vue&type=script&lang=js"
export * from "./CustomExportsInductions.vue?vue&type=script&lang=js"
import style0 from "./CustomExportsInductions.vue?vue&type=style&index=0&id=36e26ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e26ca6",
  null
  
)

export default component.exports